import React from 'react';

import CalendarContainer from './CalendarContainer';
import EventFormModal from './EventFormModal';

import '../../vendor/libs/react-datepicker/react-datepicker.scss';

const CalendarPage = () => (
  <div>
    <CalendarContainer />
    <EventFormModal />
  </div>
);

export default CalendarPage;
